import { Link } from "react-router-dom";
import styled from "styled-components";

export const IconWrapper = styled.div`
  margin-right: 8px;
  color: red;
`;

export const StyledLink = styled(Link)`
  /* Add any additional styles for the link element */
`;

export const ImageElement = styled.img`
  width: 64px;
  height: 64px;
`;
